import $ from 'jquery';

class FileHelper {
    static registerGlobalDropZone($dropZone, $dropZoneAppend) {

        let globalDragCounter = 0,
            innerDragCounter = 0;

        $dropZoneAppend = $dropZoneAppend ? $($dropZoneAppend) : null;

        let innerDragOver = function (event) {

            event.preventDefault();

        };

        let innerDragEnter = function (event) {

            if (typeof event !== 'undefined') {
                innerDragCounter++;
                if (innerDragCounter !== 1) {
                    return;
                }
            }

            $dropZone.addClass('drop-over');

            if ($dropZoneAppend) {
                $dropZoneAppend.addClass('drop-over');
            }

        };

        let innerDragLeave = function (event) {

            if (typeof event !== 'undefined') {
                innerDragCounter = Math.max(innerDragCounter - 1, 0);
                if (innerDragCounter > 0) {
                    return;
                }
            } else {
                innerDragCounter = 0;
            }

            $dropZone.removeClass('drop-over');

            if ($dropZoneAppend) {
                $dropZoneAppend.removeClass('drop-over');
            }

        };

        let innerDragDrop = function () {
            endGlobalDrag();
        };

        let startGlobalDrag = function (event) {

            if (typeof event !== 'undefined') {
                globalDragCounter++;
                if (globalDragCounter !== 1) {
                    return;
                }
            }

            $dropZone.addClass('drop-available');

            if ($dropZoneAppend) {
                $dropZoneAppend.appendTo($dropZone);
            }

            ($dropZoneAppend || $dropZone)
                .on('dragover', innerDragOver)
                .on('dragenter', innerDragEnter)
                .on('dragleave', innerDragLeave)
                .on('drop', innerDragDrop);

        };

        let allowGlobalDrag = function (event) {

            event.preventDefault();

        };

        let endGlobalDrag = function (event) {

            if (typeof event !== 'undefined') {
                globalDragCounter = Math.max(globalDragCounter - 1, 0);
                if (globalDragCounter > 0) {
                    return;
                }
            } else {
                globalDragCounter = 0;
            }

            $dropZone.removeClass('drop-available');

            if ($dropZoneAppend) {
                $dropZoneAppend.detach();
            }

            ($dropZoneAppend || $dropZone)
                .off('dragover', innerDragOver)
                .off('dragenter', innerDragEnter)
                .off('dragleave', innerDragLeave)
                .off('drop', innerDragDrop);

            innerDragLeave();

        };

        let globalDrop = function () {
            setTimeout(function () {
                endGlobalDrag();
            }, 0);
        };

        $(window)
            .on('dragover', allowGlobalDrag)
            .on('dragenter', startGlobalDrag)
            .on('dragleave', endGlobalDrag)
            .on('drop', globalDrop);

        $dropZone.data('global-dropzone', {
            allowGlobalDrag: allowGlobalDrag,
            startGlobalDrag: startGlobalDrag,
            endGlobalDrag: endGlobalDrag,
            globalDrop: globalDrop,
        });

        return $dropZone;
    }

    static unregisterGlobalDropZone($dropZone) {
        if (!$dropZone) return;
        let dropData = $dropZone.data('global-dropzone');

        if (dropData) {
            $(window)
                .off('dragover', dropData.allowGlobalDrag)
                .off('dragenter', dropData.startGlobalDrag)
                .off('dragleave', dropData.endGlobalDrag)
                .off('drop', dropData.globalDrop);
            dropData.endGlobalDrag();
            $dropZone.removeData('global-dropzone');
        }

        return $dropZone;
    }
}

export default FileHelper;
